(ns hai.ui.viewport
  "The window width at which the web-app takes its mobile layout, shared so
   that code outside the web-app follows the same layout. The width is the
   web-app's `:window/width`; the extension never writes it, so there the
   layout is never mobile.")

(def ^:private mobile-max-width 768)

(defn mobile-width?
  "Whether a window `width` px wide takes the mobile layout."
  [width]
  (boolean (and width (<= width mobile-max-width))))

(defn mobile?
  "Whether the window whose width app-db `db` holds takes the mobile layout."
  [db]
  (mobile-width? (:window/width db)))
